<ng-container *ngIf="filter?.fieldConstraints?.length > 0; else noValue">
  <div class="pe-2" *ngFor="let constraint of filter.fieldConstraints; let first = first">
    <ng-container *ngIf="(constraint.value !== null && constraint.value !== undefined) || constraint.matchMode === 'exists' || constraint.matchMode === 'notExists'; else noValue">
      <div class="badge rounded-pill bg-blue-800 fs-4 me-1 mb-1 border-radius-1" *ngIf="filter.fieldConstraints.length > 1 && !first">{{ config.getTranslation(filter.operator) }}</div>
      <div class="badge rounded-pill bg-indigo-300 fs-4 me-1 mb-1 border-radius-1">{{ config.getTranslation(constraint.matchMode) }}</div>
      <div class="badge rounded-pill bg-success fs-4 me-1 mb-1 text-wrap text-break border-radius-1" *ngIf="constraint.matchMode !== 'exists' && constraint.matchMode !== 'notExists'">
        <ng-container *ngIf="Array.isArray(constraint.value); else defaultValue">
          <ng-container *ngFor="let val of constraint.value | slice: 0: (constraint['showAll'] ? undefined : 10); let last = last">
            <ng-container *ngIf="!valueTemplate && constraint.matchMode != 'exists'">
              {{ val }}
            </ng-container>
            <ng-container
              [ngTemplateOutlet]="valueTemplate"
              [ngTemplateOutletContext]="{ value: val, matchMode: constraint.matchMode, operator: constraint.operator }">
            </ng-container>
            <span *ngIf="!last" class="text-yellow-500"> OR </span>
            <a *ngIf="last && constraint.value.length > 10" class="badge bg-purple ms-1 ps-1" (click)="constraint['showAll'] = !constraint['showAll']">
              {{constraint['showAll'] ? '-' : '+'}}{{constraint.value.length - 10}}
              </a>
          </ng-container>
        </ng-container>
        <ng-template #defaultValue>
          <ng-container *ngIf="!valueTemplate && constraint.matchMode != 'exists'">
            <ng-container [ngSwitch]="filter.type">
              <ng-container *ngSwitchCase="'date'">{{ constraint.value | date: 'shortDate' }}</ng-container>
              <ng-container *ngSwitchDefault>{{ constraint.value }}</ng-container>
            </ng-container>

          </ng-container>
          <ng-container
            [ngTemplateOutlet]="valueTemplate"
            [ngTemplateOutletContext]="{ value: constraint.value, matchMode: constraint.matchMode, operator: constraint.operator }">
          </ng-container>
        </ng-template>

      </div>
    </ng-container>
  </div>
</ng-container>
<ng-template #noValue>
  <ng-container
    [ngTemplateOutlet]="filter?.filterTemplate"
    [ngTemplateOutletContext]="{ value: null, filterCallback: onFilter }">
  </ng-container>
</ng-template>
